import { useNavigate } from "react-router-dom";
import Seo from "../components/Seo";
import "../components/booth/tokens.css";
import BoothMark from "../components/booth/BoothMark";
import TermsOfServiceContent from "../components/booth/TermsOfServiceContent";
import Footer from "../components/booth/Footer";
import "./Legal.css";

function TermsOfService() {
  const navigate = useNavigate();

  return (
    <div className="booth booth-legal-page">
      <Seo
        title="Terms of service — The Booth"
        description="The terms governing your use of The Booth's fantasy football coverage platform."
        path="/termsOfService"
      />
      <header className="booth-shell booth-legal-masthead">
        <a
          href="/"
          className="booth-legal-mark-link"
          onClick={(e) => {
            e.preventDefault();
            navigate("/");
          }}
        >
          <BoothMark />
        </a>
      </header>
      <main className="booth-shell booth-legal-main">
        <TermsOfServiceContent />
      </main>
      <Footer />
    </div>
  );
}

export default TermsOfService;
